<template>
  <b-card body-bg-variant="light"
          header="Equipment"
          header-bg-variant="dark"
          header-text-variant="light">

    <p class="p-form-label">Will the experiment/sample preparation be performed only within the beamline area?</p>
    <extended-radio-group v-model="data.general.is_preparation_within_beamline_area_only"
                          :disabled="!editable"
                          :options="yesNo"
                          size="lg"/>

    <div v-if="data.general.is_preparation_within_beamline_area_only === false">
      <p class="p-form-label">Select the laboratories required to carry out the experiment</p>
      <extended-checkbox-group v-model="data.general.laboratories"
                               :disabled="!editable"
                               :isInvalid="$data.$v.data.general.laboratories"
                               :options="laboratoriesOptions"/>

      <p>
        Please refer to the laboratory portfolio available at the link below to select the appropriate facilities
        required for the experiment:<br/>
        <a href="https://synchrotron.uj.edu.pl/en_GB/laboratoria"
           target="_blank">
          https://synchrotron.uj.edu.pl/en_GB/laboratoria
        </a>
      </p>
    </div>

    <extended-text-area v-model="data.general"
                        :editable="editable"
                        :fields="equipmentTextFields"
                        :validation="$data.$v.data.general"/>

  </b-card>
</template>

<script>
  import yesNo from '@/json/radioButtonYesNo';
  import ExtendedRadioGroup from '@/components/ExtendedRadioGroup';
  import ExtendedCheckboxGroup from '@/components/ExtendedCheckboxGroup';
  import ExtendedTextArea from '@/components/ExtendedTextArea';
  import { generalPart } from '@/helpers/proposal-form/generalPart';

  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Equipment',
    props: {
      value: undefined,
      validation: undefined,
      editable: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      ExtendedRadioGroup,
      ExtendedCheckboxGroup,
      ExtendedTextArea,
    },
    data() {
      return {
        data: this.value,
        yesNo,
        $v: this.validation,
        generalPart,
        equipmentTextFields: generalPart.equipment.textFields,
      };
    },
    computed: {
      laboratoriesOptions() {
        return this.generalPart.equipment.laboratories.map((laboratory) => ({ name: laboratory }));
      },
    },
    methods: {
      updateTextFieldsIsRequiredValue(value) {
        this.equipmentTextFields = this.equipmentTextFields.map((field) => {
          if (field.model === 'process_in_lab' || field.model === 'solaris_equipment') {
            return { ...field, isRequired: value };
          }
          return { ...field };
        });
      },
    },
    watch: {
      value: {
        handler() {
          this.data = this.value;
          if (this.data.general === undefined) this.data.general = {};
        },
        deep: true,
      },
      'data.general.is_preparation_within_beamline_area_only': function () {
        if (this.data.general.is_preparation_within_beamline_area_only === true) {
          delete this.data.general.laboratories;
          this.updateTextFieldsIsRequiredValue(false);
        } else {
          this.updateTextFieldsIsRequiredValue(true);
        }
      },
    },
  };
</script>
